var map = {
	"./api.svg": 1988,
	"./apps.svg": 1989,
	"./arrow-left-line.svg": 987,
	"./arrow-right-line.svg": 988,
	"./bell.svg": 989,
	"./chart-line.svg": 1990,
	"./chat-bubble-question.svg": 1991,
	"./chevron-down.svg": 990,
	"./clapper.svg": 1992,
	"./clock.svg": 1993,
	"./cog.svg": 1994,
	"./controller.svg": 1995,
	"./download.svg": 991,
	"./export.svg": 992,
	"./folder-open.svg": 1996,
	"./inbox.svg": 1997,
	"./key.svg": 1998,
	"./lightning-bolt.svg": 1999,
	"./lock.svg": 2000,
	"./megaphone.svg": 2001,
	"./message.svg": 2002,
	"./messages.svg": 2003,
	"./restore-page.svg": 2004,
	"./rotate-auto.svg": 2005,
	"./search-insights.svg": 2006,
	"./smiley.svg": 2007,
	"./tag.svg": 2008,
	"./user-card.svg": 2009,
	"./user-group.svg": 2010,
	"./user.svg": 2011,
	"./whatsapp.svg": 2012,
	"./work.svg": 2013,
	"./workflow.svg": 2014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1088;